// Tog'a #342 (katalog #6024): chat → «📞 Позвонить через интернет» — 1:1 WebRTC ovozli qo'ng'iroq.
// Tog'a #273 (2026-10-31): «📹 Видео» — o'sha qo'ng'iroq kamera bilan. Server o'zgarmagan: video borligi SDP'dan (m=video) aniqlanadi;
// qabul qiluvchi ham kamerasini qo'shadi (kamera bo'lmasa/ruxsat berilmasa — faqat ovoz bilan qabul qiladi, qarshi tomonning videosini ko'radi).
// Signal /socket orqali (backend WebSocket/Services/CallSignal): call_invite → ikkinchi tomonning onlayn foydalanuvchilariga jiringlaydi,
// birinchi «Принять» bosgan oladi (qolganlarda «taken»). ICE nomzodlari SDP ichida (yig'ilib bo'lgach yuboriladi) — trickle yo'q.
// Media to'g'ridan-to'g'ri (P2P, STUN); TURN sozlanmagan — juda qattiq tarmoqlarda ulanmasligi mumkin (xabar chiqadi).
// Global: Header ichida bitta nusxa. Boshlash — window «crm-call-start» {counterpartyId, name, video?} (ChatHeader tugmalari).
import React, { useEffect, useRef, useState } from "react"
import { Button, Modal, notification } from "antd"
import { PhoneOutlined, AudioMutedOutlined, AudioOutlined, VideoCameraOutlined, VideoCameraAddOutlined, ExpandOutlined, CompressOutlined } from "@ant-design/icons"

type Faza = "idle" | "calling" | "ringing" | "active"
type Holat = { faza: Faza; callId?: string; nom?: string; cpNom?: string; boshlandi?: number; video?: boolean }

const ICE: RTCConfiguration = { iceServers: [{ urls: "stun:stun.l.google.com:19302" }] }
const yubor = (o: any): boolean => { const f = (window as any).__crmWsSend; return f ? !!f(o) : false }
const yangiId = () => Math.random().toString(36).slice(2) + Date.now().toString(36)
const sdpVideo = (sdp?: string | null) => /\r?\nm=video /.test(sdp || "")

/** ICE yig'ilishini kutish (ko'pi bilan 3 s) — keyin SDP'da nomzodlar bor */
function iceKut(pc: RTCPeerConnection, ms = 3000): Promise<void> {
  if (pc.iceGatheringState === "complete") return Promise.resolve()
  return new Promise((ok) => {
    const t = setTimeout(ok, ms)
    pc.addEventListener("icegatheringstatechange", () => { if (pc.iceGatheringState === "complete") { clearTimeout(t); ok() } })
  })
}

/** Media oqimini <video>/<audio> ga ulash */
function Oqim({ stream, muted, mirror, className, style }: { stream: MediaStream | null; muted?: boolean; mirror?: boolean; className?: string; style?: React.CSSProperties }) {
  const ref = useRef<HTMLVideoElement>(null)
  useEffect(() => {
    const el = ref.current
    if (!el) return
    el.srcObject = stream
    if (stream) { const p = el.play(); if (p && p.catch) p.catch(() => {}) }
    return () => { if (el) el.srcObject = null }
  }, [stream])
  return <video ref={ref} className={className} autoPlay playsInline muted={muted} style={{ ...(style || {}), transform: mirror ? "scaleX(-1)" : undefined }} />
}

export default function CallManager() {
  const [h, setH] = useState<Holat>({ faza: "idle" })
  const [ovozsiz, setOvozsiz] = useState(false)
  const [kameraOff, setKameraOff] = useState(false)
  const [katta, setKatta] = useState(false)
  const [meniki, setMeniki] = useState<MediaStream | null>(null)     // o'z kamera oqimi (PiP)
  const [qarshi, setQarshi] = useState<MediaStream | null>(null)     // qarshi tomon oqimi
  const [qarshiVideo, setQarshiVideo] = useState(false)             // qarshi tomondan video keladimi
  const [, setTik] = useState(0)
  const hRef = useRef<Holat>(h); hRef.current = h
  const pc = useRef<RTCPeerConnection | null>(null)
  const mic = useRef<MediaStream | null>(null)
  const audio = useRef<HTMLAudioElement | null>(null)
  const taklif = useRef<string | null>(null)   // kiruvchi offer SDP
  const kutish = useRef<any>(null)
  const jiring = useRef<any>(null)

  const jiringTo = () => { clearInterval(jiring.current); jiring.current = null }
  const jiringla = () => {
    jiringTo()
    const bip = () => { try { const C = (window as any).AudioContext || (window as any).webkitAudioContext; const ac = new C(); const o = ac.createOscillator(); const g = ac.createGain(); o.frequency.value = 660; g.gain.value = 0.08; o.connect(g); g.connect(ac.destination); o.start(); setTimeout(() => { o.stop(); ac.close() }, 400) } catch {} }
    bip(); jiring.current = setInterval(bip, 1500)
  }
  const tozala = () => {
    jiringTo(); clearTimeout(kutish.current)
    try { pc.current?.close() } catch {}
    pc.current = null
    mic.current?.getTracks().forEach((t) => t.stop()); mic.current = null
    if (audio.current) audio.current.srcObject = null
    taklif.current = null; setOvozsiz(false); setKameraOff(false); setKatta(false)
    setMeniki(null); setQarshi(null); setQarshiVideo(false)
    setH({ faza: "idle" })
  }
  const tugat = (reason = "hangup") => { const c = hRef.current.callId; if (c) yubor({ type: "call_end", callId: c, reason }); tozala() }

  /** Mikrofon (+ kamera). Kamera so'ralgan, lekin yo'q/ruxsat berilmagan bo'lsa — faqat ovoz bilan davom etadi. */
  const yangiPc = async (video: boolean) => {
    let s: MediaStream
    if (video) {
      try {
        s = await navigator.mediaDevices.getUserMedia({ audio: true, video: { facingMode: "user", width: { ideal: 1280 }, height: { ideal: 720 } } })
      } catch (er: any) {
        // kamera yo'q yoki band — ovoz bilan (mikrofon xatosi bo'lsa — pastga tashlanadi)
        s = await navigator.mediaDevices.getUserMedia({ audio: true })
        notification.info({ message: "Камера недоступна — звонок без вашего видео" })
      }
    } else {
      s = await navigator.mediaDevices.getUserMedia({ audio: true })
    }
    mic.current = s
    setMeniki(s.getVideoTracks().length ? s : null)
    const p = new RTCPeerConnection(ICE)
    s.getTracks().forEach((t) => p.addTrack(t, s))
    p.ontrack = (e) => {
      const st = e.streams[0]
      if (!st) return
      setQarshi(st)
      const bor = () => setQarshiVideo(st.getVideoTracks().some((t) => t.readyState === "live" && !t.muted))
      bor()
      st.getVideoTracks().forEach((t) => { t.onmute = bor; t.onunmute = bor; t.onended = bor })
      // ovoz — audio elementidan (video oynasi yopiq bo'lsa ham eshitiladi)
      if (audio.current) { audio.current.srcObject = st; audio.current.play().catch(() => {}) }
    }
    p.onconnectionstatechange = () => {
      if (p.connectionState === "failed") { notification.error({ message: "Связь не установилась — сеть не пропускает звонок" }); tugat("failed") }
    }
    pc.current = p
    return p
  }

  // chiquvchi qo'ng'iroq
  useEffect(() => {
    const boshla = async (e: any) => {
      if (hRef.current.faza !== "idle") return
      const { counterpartyId, name, video } = e.detail || {}
      if (!(window as any).__crmWsSend) { notification.error({ message: "Нет соединения с сервером — обновите страницу" }); return }
      if (!navigator.mediaDevices?.getUserMedia) { notification.error({ message: "Браузер не поддерживает звонки (нужен HTTPS и микрофон)" }); return }
      const callId = yangiId()
      setH({ faza: "calling", callId, cpNom: name, nom: name, video: !!video })
      try {
        const p = await yangiPc(!!video)
        // Tog'a #273: video qo'ng'iroqda qarshi tomon kamerasini ham qabul qilamiz (o'zimizda kamera bo'lmasa ham)
        const offer = await p.createOffer(video ? { offerToReceiveAudio: true, offerToReceiveVideo: true } : undefined)
        await p.setLocalDescription(offer)
        await iceKut(p)
        if (hRef.current.callId !== callId) return   // kutishda bekor qilindi
        yubor({ type: "call_invite", callId, counterpartyId, sdp: p.localDescription?.sdp })
        kutish.current = setTimeout(() => { if (hRef.current.faza === "calling" && hRef.current.callId === callId) { notification.info({ message: "Никто не ответил" }); tugat("no_answer") } }, 45000)
      } catch (er: any) {
        notification.error({ message: /denied|Permission/i.test(String(er?.message || er)) ? "Нет доступа к микрофону — разрешите в браузере" : "Не удалось начать звонок" })
        tozala()
      }
    }
    window.addEventListener("crm-call-start", boshla)
    return () => window.removeEventListener("crm-call-start", boshla)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // signal xabarlari
  useEffect(() => {
    const ol = async (e: any) => {
      const m = e.detail || {}, d = m.data || {}, cur = hRef.current
      switch (m.typeFunction) {
        case "invite":
          if (cur.faza !== "idle") { yubor({ type: "call_end", callId: d.callId, reason: "busy" }); return }
          taklif.current = d.sdp
          setH({ faza: "ringing", callId: d.callId, nom: d.fromName, cpNom: d.counterpartyName, video: sdpVideo(d.sdp) })   // #273: video SDP'dan
          jiringla()
          return
        case "unavailable":
          if (d.callId !== cur.callId) return
          notification.warning({ message: d.reason === "forbidden" ? "Нет доступа к этому чату" : "Сейчас никого нет в сети — напишите сообщение" })
          tozala(); return
        case "answer":
          if (cur.faza !== "calling" || d.callId !== cur.callId || !pc.current) return
          clearTimeout(kutish.current)
          try { await pc.current.setRemoteDescription({ type: "answer", sdp: d.sdp }) } catch { notification.error({ message: "Ошибка соединения" }); tugat("failed"); return }
          setH({ ...cur, faza: "active", nom: d.byName || cur.nom, boshlandi: Date.now() })
          return
        case "taken":
          if (cur.faza === "ringing" && d.callId === cur.callId) tozala()
          return
        case "end":
          if (d.callId !== cur.callId) return
          if (cur.faza === "calling" && d.reason === "rejected") notification.info({ message: "Звонок отклонён" })
          else if (cur.faza === "active") notification.info({ message: "Звонок завершён" })
          tozala(); return
      }
    }
    window.addEventListener("crm-call", ol)
    return () => window.removeEventListener("crm-call", ol)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // davomiylik
  useEffect(() => {
    if (h.faza !== "active") return
    const t = setInterval(() => setTik((x) => x + 1), 1000)
    return () => clearInterval(t)
  }, [h.faza])
  // sahifa yopilsa — qo'ng'iroq tugaydi
  useEffect(() => {
    const f = () => { const c = hRef.current; if (c.faza !== "idle" && c.callId) yubor({ type: "call_end", callId: c.callId, reason: c.faza === "ringing" ? "rejected" : "hangup" }) }
    window.addEventListener("beforeunload", f)
    return () => window.removeEventListener("beforeunload", f)
  }, [])

  const qabul = async () => {
    const cur = hRef.current
    jiringTo()
    try {
      const p = await yangiPc(!!cur.video)   // #273: video qo'ng'iroq — kamera bilan qabul
      await p.setRemoteDescription({ type: "offer", sdp: taklif.current || "" })
      await p.setLocalDescription(await p.createAnswer())
      await iceKut(p)
      yubor({ type: "call_answer", callId: cur.callId, sdp: p.localDescription?.sdp })
      setH({ ...cur, faza: "active", boshlandi: Date.now() })
    } catch (er: any) {
      notification.error({ message: /denied|Permission/i.test(String(er?.message || er)) ? "Нет доступа к микрофону — разрешите в браузере" : "Не удалось принять звонок" })
      tugat("rejected")
    }
  }
  const ovoz = () => { const v = !ovozsiz; mic.current?.getAudioTracks().forEach((t) => (t.enabled = !v)); setOvozsiz(v) }
  const kamera = () => { const v = !kameraOff; mic.current?.getVideoTracks().forEach((t) => (t.enabled = !v)); setKameraOff(v) }
  const vaqt = h.boshlandi ? Math.floor((Date.now() - h.boshlandi) / 1000) : 0
  const mmss = `${String(Math.floor(vaqt / 60)).padStart(2, "0")}:${String(vaqt % 60).padStart(2, "0")}`
  const videoRejim = !!h.video || qarshiVideo || !!meniki   // #273: kimdadir kamera bor — video oyna
  const belgi = h.video ? "📹" : "📞"

  return (
    <>
      <audio ref={audio} autoPlay playsInline style={{ display: "none" }} />
      <Modal visible={h.faza === "ringing"} closable={false} maskClosable={false} footer={null} zIndex={2000} width={360} centered>
        <div style={{ textAlign: "center" }} data-testid="call-incoming">
          <div style={{ fontSize: 40 }}>{belgi}</div>
          <div style={{ fontSize: 16, fontWeight: 700, marginTop: 6 }}>{h.nom || "Звонок"}</div>
          {h.cpNom ? <div style={{ color: "#64748b" }}>{h.cpNom}</div> : null}
          <div style={{ color: "#64748b", marginTop: 4 }}>{h.video ? "Входящий видеозвонок через интернет" : "Входящий звонок через интернет"}</div>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", marginTop: 16 }}>
            <Button type="primary" size="large" style={{ background: "#16a34a", borderColor: "#16a34a" }} icon={h.video ? <VideoCameraOutlined /> : <PhoneOutlined />} onClick={qabul} data-testid="call-accept">Принять</Button>
            <Button danger size="large" onClick={() => tugat("rejected")} data-testid="call-reject">Отклонить</Button>
          </div>
        </div>
      </Modal>
      {(h.faza === "calling" || h.faza === "active") && (
        videoRejim ? (
          // Tog'a #273: video oyna — qarshi tomon katta, o'zimiz kichik burchakda; «Развернуть» — butun ekran
          <div data-testid="call-panel" style={katta
            ? { position: "fixed", inset: 0, zIndex: 2000, background: "#000", display: "flex", flexDirection: "column" }
            : { position: "fixed", left: 16, bottom: 16, zIndex: 2000, width: "min(420px, calc(100vw - 32px))", background: "#0f172a", color: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 8px 24px rgba(0,0,0,.35)", display: "flex", flexDirection: "column" }}>
            <div style={{ position: "relative", flex: 1, minHeight: katta ? 0 : 236, background: "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>
              {qarshiVideo && qarshi ? (
                <Oqim stream={qarshi} muted style={{ width: "100%", height: katta ? "100%" : 236, objectFit: katta ? "contain" : "cover", display: "block" }} />
              ) : (
                <div style={{ textAlign: "center", color: "#cbd5e1", padding: 16 }}>
                  <div style={{ fontSize: 44 }}>{belgi}</div>
                  <div style={{ fontWeight: 700, color: "#fff" }}>{h.nom || h.cpNom || "Звонок"}</div>
                  <div style={{ fontSize: 12, opacity: 0.8 }} data-testid="call-status">{h.faza === "calling" ? "Вызов…" : h.video ? "Собеседник без камеры · " + mmss : mmss}</div>
                </div>
              )}
              {meniki && !kameraOff && (
                <Oqim stream={meniki} muted mirror style={{ position: "absolute", right: 10, top: 10, width: katta ? 220 : 110, aspectRatio: "4 / 3", objectFit: "cover", borderRadius: 10, border: "1px solid rgba(255,255,255,.35)", background: "#111" }} />
              )}
              {qarshiVideo && qarshi && (
                <div style={{ position: "absolute", left: 10, bottom: 8, background: "rgba(0,0,0,.55)", color: "#fff", borderRadius: 8, padding: "2px 8px", fontSize: 12 }}>
                  <b>{h.nom || h.cpNom || "Звонок"}</b> · <span data-testid="call-status">{h.faza === "calling" ? "Вызов…" : mmss}</span>
                </div>
              )}
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "center", alignItems: "center", padding: "10px 12px", background: katta ? "#0f172a" : undefined }}>
              {h.faza === "active" && <Button shape="circle" icon={ovozsiz ? <AudioMutedOutlined /> : <AudioOutlined />} onClick={ovoz} title={ovozsiz ? "Включить микрофон" : "Выключить микрофон"} data-testid="call-mute" />}
              {meniki && <Button shape="circle" icon={kameraOff ? <VideoCameraAddOutlined /> : <VideoCameraOutlined />} onClick={kamera} title={kameraOff ? "Включить камеру" : "Выключить камеру"} data-testid="call-camera" />}
              <Button shape="circle" icon={katta ? <CompressOutlined /> : <ExpandOutlined />} onClick={() => setKatta((v) => !v)} title={katta ? "Свернуть" : "Развернуть"} data-testid="call-expand" />
              <Button danger type="primary" shape="round" onClick={() => tugat(h.faza === "calling" ? "cancel" : "hangup")} data-testid="call-hangup">Завершить</Button>
            </div>
          </div>
        ) : (
          <div data-testid="call-panel" style={{ position: "fixed", left: 16, bottom: 16, zIndex: 2000, background: "#0f172a", color: "#fff", borderRadius: 14, padding: "10px 14px", boxShadow: "0 8px 24px rgba(0,0,0,.35)", display: "flex", alignItems: "center", gap: 10, maxWidth: "calc(100vw - 32px)" }}>
            <span style={{ fontSize: 22 }}>📞</span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 200 }}>{h.nom || h.cpNom || "Звонок"}</div>
              <div style={{ fontSize: 12, opacity: 0.8 }} data-testid="call-status">{h.faza === "calling" ? "Вызов…" : mmss}</div>
            </div>
            {h.faza === "active" && <Button shape="circle" icon={ovozsiz ? <AudioMutedOutlined /> : <AudioOutlined />} onClick={ovoz} title={ovozsiz ? "Включить микрофон" : "Выключить микрофон"} data-testid="call-mute" />}
            <Button danger type="primary" shape="round" onClick={() => tugat(h.faza === "calling" ? "cancel" : "hangup")} data-testid="call-hangup">Завершить</Button>
          </div>
        )
      )}
    </>
  )
}
